// Helpers for the Launchpad video slots. Video entries live in setupContent.js
// as { provider: 'youtube', youtubeId, start?, title, ... } or
// { provider: 'wistia', mediaId, ... }.

// YouTube serves a 120px-wide grey placeholder (not always a load error) when
// a video has no maxres thumbnail
export const YOUTUBE_PLACEHOLDER_WIDTH = 120

export const hasVideoMedia = (video) => !!(video && (video.youtubeId || video.mediaId))

export const youtubeThumbnailUrl = (youtubeId, quality = 'maxresdefault') => {
  return `https://i.ytimg.com/vi/${youtubeId}/${quality}.jpg`
}

export const youtubeEmbedUrl = (youtubeId, start = 0) => {
  const params = ['autoplay=1', `start=${Math.max(0, Math.floor(start || 0))}`, 'rel=0']
  return `https://www.youtube-nocookie.com/embed/${youtubeId}?${params.join('&')}`
}
